import { useMemo } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { useStore } from 'store';
import { isLogged } from 'services/commons/sessions';
import { useStorage64 } from 'hooks';
import { TOTAL_GIFT_TABLES, TOTAL_GIFT_TABLES_OPEN, TOTAL_GIFT_TABLES_CLOSED} from 'constants/storage64';

export default function useGiftTableInfo() {
  const [giftTable] = useStore((state) => state.giftTable.giftTable);
  const [agentStaffId] = useStore((state) => state.commons.agentStaffId);
  const [totalGiftTables] = useStorage64(TOTAL_GIFT_TABLES);
  const [totalGiftTablesOpen] = useStorage64(TOTAL_GIFT_TABLES_OPEN);
  const [totalGiftTablesClosed] = useStorage64(TOTAL_GIFT_TABLES_CLOSED);

  const logged = isLogged();

  const hasGiftTableAndIsLogged = useMemo(
    () => logged && !_isEmpty(giftTable) && !agentStaffId,
    [logged, giftTable, agentStaffId]
  );

  const hasGiftTableNotOpenAndIsLogged = useMemo(
    () => logged && (totalGiftTables > 0 && totalGiftTablesOpen === 0 && totalGiftTablesClosed > 0) && !agentStaffId,
    [logged, giftTable, agentStaffId, totalGiftTables, totalGiftTablesOpen, totalGiftTablesClosed]
  );

  return { hasGiftTableAndIsLogged, hasGiftTableNotOpenAndIsLogged };
}
